import React, { Component } from 'react';

export default class Head extends Component {
	render() {
		return <div style={{}}>
			<img src={require('./img/assist_1.png')} style={{
				position:"absolute",
				left: 0,
				top: 32,
				width:"100%",
				height:"auto"
			}} />
			<span style={{
				position:"absolute",
				left: 24,
				right: 24,
				top: 82,
				textAlign: "center",
				fontSize: 22,
			}}> Meet your Google Assistant </span>
			<span style={{
				position:"absolute",
				left: 24,
				right: 24,				
				top: 126,
				textAlign: "center",
				fontSize: 16,
			}}>Ask it questions. Tell it to do things. It's your own personal Google, always ready to help.</span>
			<div style={{
				position:"absolute",
				left: 72,
				right: 72,				
				top: 354,
				height: 64,
				// backgroundColor: "rgba(255,0,0,0.3)",
				fontSize: 22,
				textAlign: "center",
				display: "flex",
				alignItems: "center",
				justifyContent:"space-around",
			}}>Hi, how can I help?</div>

		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/Assist_1.js